import { Card, Col, Row } from "react-bootstrap";
import ReactECharts from 'echarts-for-react';
import { FiBarChart2, FiFileText } from "react-icons/fi";
import { RiArrowRightUpLine } from "react-icons/ri";

const SubscriptionAnalytics = () => {
    let growthData = ['58', '142', '98', '112', '90', '161', '78', '142', '38', '112', '64', '98'].map(Number);
    let maxVal = Math.max(...growthData);

    const distributionData = [
        { value: '22', name: 'Basic' },
        { value: '18', name: 'Professional' },
        { value: '35', name: 'Premium' },
        { value: '25', name: 'Enterprise' },
    ];
    let pieChartColors = ['#13D4B1', '#93A1E8', '#81DE2F', '#EA9BEB', '#73C0DE'];

    return ( <>
    <div className="container-fluid py-3">
        <Card body>
            <Card.Subtitle className="mb-3 fw-semibold">Analytics</Card.Subtitle>
            <Row xs={1} md={2} className="g-3 justify-content-center">
                <Col>
                    <Card body className="h-100">
                        <Card.Subtitle className="hstack justify-content-between">
                            <span className="fs-6">Subscription Growth</span>
                            <span className="hstack link-secondary" role="button">
                                <span>Last 12 months</span>
                                <RiArrowRightUpLine size={16} className="ms-2" />
                            </span>
                        </Card.Subtitle>
                        <div className="p-2 hstack justify-content-between">
                            <div className="fs-3 fw-semibold">890</div>
                            <div className='icon rounded-1 p-1' style={{ backgroundColor: "#F4F7FE" }}>
                                <FiBarChart2 size={26} />
                            </div>
                        </div>
                        <div className="p-2 w-100">
                            <ReactECharts className="w-100 mb-0" style={{ height: "230px" }}
                                option={{
                                    tooltip: {
                                        show: true,
                                    },
                                    grid: {
                                        top: '1%',
                                        right: '0%',
                                        bottom: '1%',
                                        left: '-5%',
                                        containLabel: true
                                    },
                                    xAxis: {
                                        type: 'category',
                                        data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                                        axisLine: {
                                            show: false // Removes the black line on the x-axis
                                        },
                                        axisTick: {
                                            show: false // Hides the small vertical tick marks
                                        }
                                    },
                                    yAxis: {
                                        type: 'value',
                                        axisLabel: {
                                            formatter: '{value}',
                                        },
                                        min: 0,
                                        max: Math.ceil(maxVal / 20) * 20, // 172
                                        interval: 20,
                                        show: false
                                    },
                                    legend: {
                                        bottom: "0",
                                        icon: "rect",
                                        itemWidth: 8,
                                        itemHeight: 8,
                                        textStyle: {
                                            color: '#333',
                                            fontSize: 14,
                                        },
                                        show: false,
                                    },
                                    series: [
                                        {
                                            name: "Subscription Growth",
                                            type: 'bar',
                                            itemStyle: {
                                                borderRadius: [8, 8, 8, 8],
                                                color: (params) => {
                                                    return params.value === maxVal ? '#0077B6' : '#E9E9E9';
                                                },
                                            },
                                            emphasis: {
                                                focus: 'series',
                                                itemStyle: {
                                                    color: 'inherit', 
                                                    opacity: 0.5
                                                }
                                            },
                                            data: growthData,
                                            // Adds the dashed 'MAX' line
                                            markLine: {
                                                symbol: ['none', 'none'],
                                                data: [
                                                    {
                                                        yAxis: maxVal + 5, // Adds a gap of 5 above the highest value,
                                                        label: {
                                                            formatter: 'MAX',
                                                            position: 'insideEnd',
                                                            fontSize: 12,
                                                            fontWeight: 'bold',
                                                            color: '#333333',
                                                            backgroundColor: '#FFFFFF'
                                                        },
                                                    }
                                                ],
                                                silent: true,
                                                lineStyle: {
                                                    type: 'dashed',
                                                    color: '#0077B6',
                                                    width: 1
                                                },
                                            }
                                        }
                                    ]
                                }}
                                opts={{ renderer: 'svg' }}
                            />
                        </div>
                    </Card>
                </Col>
                <Col>
                    <Card body className="h-100">
                        <Card.Subtitle>Plan Distribution</Card.Subtitle>
                        <div className='vstack justify-content-center' style={{ height: "100%", position: "relative", width: "100%", overflow: "hidden" }}>
                            <ReactECharts className="w-100 mb-0" style={{ height: "300px" }}
                                option={{
                                    tooltip: {
                                        trigger: 'item'
                                    },
                                    legend: {
                                        right: '5%',
                                        top: "center",
                                        orient: "vertical",
                                        icon: "circle",
                                        itemWidth: 10,
                                        itemHeight: 10,
                                        formatter: function (name) {
                                            let dataItem = distributionData.find(item => item.name === name);
                                            if (dataItem) {
                                                return `${name} - ${dataItem.value}%`;
                                            }
                                            return name;
                                        },
                                        textStyle: {
                                            color: pieChartColors,
                                        }
                                    },
                                    grid: {
                                        // top: '2%',
                                        // left: '3%',
                                        // right: '4%',
                                        // bottom: '2%',
                                        containLabel: true,
                                    },
                                    series: [
                                        {
                                            name: 'Plan Distribution',
                                            type: 'pie',
                                            radius: ['40%', '70%'],
                                            // center: ['45%', '50%'],
                                            label: {
                                                show: false,
                                            },
                                            emphasis: {
                                                scale: true,
                                                itemStyle: {
                                                    borderColor: '#fff',
                                                    borderWidth: 3,
                                                },
                                            },
                                            data: distributionData,
                                        }
                                    ],
                                }}
                                opts={{ renderer: 'svg' }}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>
        </Card>
    </div>
    </> );
}
 
export default SubscriptionAnalytics;